import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M3 3v18h18V3H3zm9 5h3V7h-3V5.5h4.5V9h-3v1h3v1.5H12V8zM7 5.5h3v6H8.5V7H7V5.5zm5.5 13H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5v6zM18 17h-3v1.5h-1.5v-6H18V17z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M15 14h1.5v1.5H15z"
}, "1")], 'TwelveMpSharp');